module.exports = __webpack_public_path__ + "static/img/news-20210427.744acec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20210427.png
// module id = pbRd
// module chunks = 0